import { Component } from '@angular/core';
import { Store } from '@ngxs/store';
import { map, Observable } from 'rxjs';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { ProductsState } from 'src/app/state/products/products.state';
import { Products } from 'src/app/state/products/products.action';
import {
  AnalysisMode,
  BOTTOM_UP_PRODUCT_ID
} from 'src/app/state/products/products.constants';

@Component({
  selector: 'app-product-navigation',
  templateUrl: './product-navigation.component.html',
  styleUrls: ['./product-navigation.component.scss']
})
export class ProductNavigationComponent {
  readonly AnalysisMode = AnalysisMode;
  readonly metricOptions$ = this.store.select(ProductsState.metricOptions);

  isAnalysisModeSwitchAvailable$: Observable<boolean> = this.store.select(ProductsState.isAnalysisModeSwitchAvailable);
  isBottomUpModeActive$: Observable<boolean> = this.store.select(ProductsState.isBottomUpModeActive);
  metricId$ = this.store.select(ProductsState.metricId);

  // The switcher already covers the bottom-up product, so it must not show up in the dropdown as well.
  excludedProductIds$: Observable<number[]> = this.isAnalysisModeSwitchAvailable$.pipe(
    map((isAnalysisModeSwitchAvailable) => isAnalysisModeSwitchAvailable ? [BOTTOM_UP_PRODUCT_ID] : [])
  );

  // Bottom-up covers a single product but every metric, top-down the other way around.
  isProductSelectorVisible$: Observable<boolean> = this.isBottomUpModeActive$.pipe(
    map((isBottomUpModeActive) => !isBottomUpModeActive)
  );

  constructor(private store: Store) {

  }

  selectAnalysisMode(mode: AnalysisMode) {
    this.store.dispatch(new Products.SelectAnalysisMode(mode));
  }

  selectMetric(event: DropdownChangeEvent) {
    this.store.dispatch(new Products.SelectMetric(event.value));
  }
}
